export default "__VITE_ASSET__MB_kh2I$__"